import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { Document } from "../../../@types/document";
import api from "../../../utils/api";
import axiosInstance from "../../../utils/axiosConfig";
import { RootState } from "../../rootReducer";

export const signDocument = createAsyncThunk(
  "documentsSignerList/signDocument",
  async (document: Document, { rejectWithValue, getState }) => {
    try {
      const state = getState() as RootState;

      const { user } = state.userAuthentication;

      await axiosInstance.post(`${api.baseURL}document/sign`, {
        document: document.id,
        user: user?.id,
      });

      return;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
